import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Toolbar, TextField, Button, Icon, DialogActions, Select as MSelect, MenuItem } from 'material-ui';
import ReactTable from "react-table";
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { TextFieldFormsy, SelectFormsy } from '@fuse';
import axios from 'axios';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";
import Select from 'react-select';
import 'react-select/dist/react-select.css'

const styles = theme => ({
    layoutRoot: {},
    input: {
        width: "100%",
        textAlign: "right",
        fontSize: '1.8rem'
    }
});


class openningBalance extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            accountList: [],
            accountTypes: [],
            accountType: null,
            accountCategories: [],
            accountCategory: null,
            mainAccounts: [],
            mainAccount: null,
            balanceType: "Credit",
            draftId: null,
            ledAccId : 0
        };

        // this.setSelectedJob = this.setSelectedJob.bind(this);

    }

    handleAccountType = (selectedOption) => {

        this.setState({ mainAccount: null });
        this.setState({ mainAccounts: [] });
        this.setState({ accountCategory: null });
        this.setState({ accountType: selectedOption });

        if (selectedOption) {

            var accountCategories = [];

            // axios.post('http://localhost:5009/accountCategory/getAccountCategoryByType',{'id':selectedOption.value})
            axios.post(window.accountServer + '/accountCategory/getAccountCategoryByType', { 'id': selectedOption.value })
                .then(response => {

                    for (let i = 0; i < response.data.accountCategories.length; i++) {

                        accountCategories.push({
                            value: response.data.accountCategories[i].ID_ACCOUNT_CATEGORY,
                            label: response.data.accountCategories[i].NAME
                        });
                    }
                    this.setState({ accountCategories: accountCategories });

                }).catch(function (error) {
                    console.log("err " + error);
                });
        }

        else {

            this.setState({ accountCategories: [] });
        }
    }


    handleAccountCategory = (selectedOption) => {

        this.setState({ mainAccount: null });
        this.setState({ accountCategory: selectedOption });

        this.loadLedgerAccountsNotMainAcc(selectedOption.value);

        if (selectedOption) {

            var mainAccounts = [];

            // axios.post('http://localhost:5009/mainAccount/getMainAccountsByCategory',{'id':selectedOption.value})
            axios.post(window.accountServer + '/mainAccount/getMainAccountsByCategory', { 'id': selectedOption.value })
                .then(response => {

                    for (let i = 0; i < response.data.mainAccounts.length; i++) {

                        mainAccounts.push({
                            value: response.data.mainAccounts[i].ID_MAIN_ACCOUNT,
                            label: response.data.mainAccounts[i].NAME
                        });
                    }
                    this.setState({ mainAccounts: mainAccounts });

                }).catch(function (error) {
                    console.log("err " + error);
                });
        }

        else {

            this.setState({ mainAccounts: [] });
        }

    }


    handleMainAccount = (selectedOption) => {

        this.setState({ mainAccount: selectedOption });

        if (selectedOption) {

            this.loadLedgerAccounts(selectedOption.value);
        }

        else {

            // this.setState({ accountList: [] });
        }

    }

    loadLedgerAccounts = (id) => {

        this.setState({ loading: true });
        this.setState({ accountList: [] });
        this.setState({ draftId: null });
        var accountList = [];
        

        // axios.post('http://localhost:5009/ledgerAccount/getLedgerAccountForOpenningBalance',{'id':id})
        axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountForOpenningBalance', { 'id': id })
            .then(response => {

                if(0 == response.data.ledgerAccountDetails.length){

                    this.loadLedgerAccountsNotMainAcc(this.state.accountCategory.value);
                }else{
                    
                    for (let i = 0; i < response.data.ledgerAccountDetails.length; i++) {

                        accountList.push({
                            index: i,
                            mainId: id,
                            id: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            ref_no: response.data.ledgerAccountDetails[i].LEDGER_REF_NO,
                            name: response.data.ledgerAccountDetails[i].NAME,
                            type: this.state.balanceType,
                            value: null,
                            isSingle: true
                        });
                    }
                }

                
                this.setState({ loading: false });
                this.setState({ accountList: accountList });

                console.log(this.state.accountList);

            }).catch(function (error) {
                console.log("err " + error);
            });
    }

    loadLedgerAccountsNotMainAcc = (id) => {

        this.setState({ loading: true });
        this.setState({ accountList: [] });
        this.setState({ draftId: null });
        var accountList = [];

        // axios.post('http://localhost:5009/ledgerAccount/getLedgerAccountForOpenningBalanceNotMainAcc',{'id':id})
        axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountForOpenningBalanceNotMainAcc', { 'id': id})
            .then(response => {

                for (let i = 0; i < response.data.ledgerAccountDetails.length; i++) {

                    accountList.push({
                        index: i,
                        mainId: id,
                        id: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                        ref_no: response.data.ledgerAccountDetails[i].LEDGER_REF_NO,
                        name: response.data.ledgerAccountDetails[i].NAME,
                        type: this.state.balanceType,
                        value: null,
                        isSingle: true
                    });
                }
                this.setState({ loading: false });
                this.setState({ accountList: accountList });

                console.log(this.state.accountList);

            }).catch(function (error) {
                console.log("err " + error);
            });
    }

    updateBalance = (data) => {
        this.setState({ loading: true });
        this.setState({ledAccId : data.ledgerAccId})
        // axios.post('http://localhost:5009/ledgerAccount/updateOpenningBalance',data)
        axios.post(window.accountServer + '/ledgerAccount/updateOpenningBalance', data)
            .then(response => {

                if (response.data.status) {
                    this.setState({ loading: false });
                    this.props.alert.success(response.data.msg);

                    if (response.data.mainId == 'Draft') {
                        this.setState({ accountList: [] });
                    }

                    else {
                        this.loadLedgerAccounts(response.data.mainId);
                    }
                }

                else {
                    this.setState({ loading: false });
                    this.props.alert.error(response.data.msg);
                }

            }).catch(function (error) {
                console.log("err " + error);
            });

    }

    pushValue = (data, index) => {

        var tmpArray = [...this.state.accountList];
        tmpArray[index].value = data.target.value;
        this.setState({ accountList: tmpArray });

    }

    pushType = (data, index) => {

        console.log(this.state.accountList[index]);
        var tmpArray = [...this.state.accountList];
        tmpArray[index].type = data.target.value;
        this.setState({ accountList: tmpArray });
        
        console.log(this.state.accountList[index]);

    }

    draftLedgerBalance = () => {
        this.setState({ loading: true });
        // axios.post('http://localhost:5009/ledgerAccount/draftOpenningBalance',this.state.accountList)
        axios.post(window.accountServer + '/ledgerAccount/draftOpenningBalance', this.state.accountList)
            .then(response => {

                if (response.data.status) {
                    this.setState({ loading: false });
                    this.props.alert.success(response.data.msg);
                    this.getDraftList();
                }

                else {
                    this.setState({ loading: false });
                    this.props.alert.error(response.data.msg);
                }

            }).catch(function (error) {
                console.log("err " + error);
            });
    }

    updateBalanceAll = () => {
        this.setState({ loading: true });
        // axios.post('http://localhost:5009/ledgerAccount/updateOpenningBalanceAll',{'account':this.state.accountList,'draft':this.state.draftId})
        axios.post(window.accountServer + '/ledgerAccount/updateOpenningBalanceAll', { 'account': this.state.accountList, 'draft': this.state.draftId })
            .then(response => {
                this.setState({ loading: false });
                if (response.data.status) {

                    this.props.alert.success(response.data.msg);
                    this.setState({ accountList: [] });
                    this.setState({ accountCategories: [] });
                    this.setState({ mainAccounts: [] });
                    this.setState({ accountType: null });
                    this.setState({ accountCategory: null });
                    this.setState({ mainAccount: null });
                    this.getDraftList();
                }

                else {
                    this.setState({ loading: false });
                    this.props.alert.error(response.data.msg);
                }

            }).catch(function (error) {
                console.log("err " + error);
            });
    }

    getDraftList = () => {

        var drafts = [];
        // axios.get('http://localhost:5009/ledgerAccount/getOpenningBalanceDraft')
        axios.get(window.accountServer + '/ledgerAccount/getOpenningBalanceDraft')

            .then(response => {

                for (let i = 0; i < response.data.length; i++) {

                    drafts.push({
                        id: response.data[i].ID_DRAFT_HEADER,
                        draftCode: response.data[i].DRAFT_CODE_PREFIX + ' ' + response.data[i].DRAFT_CODE,
                        date: response.data[i].CREATED_DATE.substring(0, 10)
                    });
                }
                this.setState({ draftList: drafts });

            }).catch(function (error) {
                console.log("err " + error);
            });
    }

    loadDraftDetails = (id) => {

        this.setState({ loading: true });
        this.setState({ accountList: [] });
        this.setState({ draftId: id });
        var draftAccountList = [];

         //axios.post('http://localhost:5009/ledgerAccount/getOpenningBalanceDraftDetails',{'id':id})
        axios.post(window.accountServer + '/ledgerAccount/getOpenningBalanceDraftDetails', { 'id': id })
            .then(response => {

                console.log("response get draft details",response.data);
                console.log("opening balance : ",response.data);

                for (let i = 0; i < response.data.length; i++) {

                    draftAccountList.push({
                        index: i,
                        refId : response.data[i].LEDGER_REF_NO,
                        mainId: 'Draft',
                        id: response.data[i].ID_LEDGER_ACCOUNT,
                        name: response.data[i].NAME_LEDGER_ACCOUNT,
                        type: response.data[i].BALANCE_TYPE,
                        value: response.data[i].BALANCE_AMOUNT,
                        isSingle: false
                    });
                }
                this.setState({ loading: false });
                this.setState({ accountList: draftAccountList });

                console.log("draft account list",draftAccountList);
                console.log("account list",this.state.accountList);

            }).catch(function (error) {
                console.log("err " + error);
            });
    }

    render() {
        const { classes } = this.props;

        var borderStyle = {
            'border-bottom': '4px solid #a779e9',
            'background-color': 'white',
            'border-style': 'inset'
        };

        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 ">

                    <Toolbar className="flex flex-wrap pt-24 px-12">
                        <h2 className="subtitle-color  w-full sm:w-1/4">
                            Opening Balance
                        </h2>
                    </Toolbar>

                    <div className="block">
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                            Account Type
                                <Select
                                className=" py-8"
                                name="accountType"
                                placeholder="Search"
                                value={this.state.accountType}
                                onChange={this.handleAccountType}
                                options={this.state.accountTypes}
                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8  inline-block">
                            Account Category
                                <Select
                                className=" py-8"
                                name="accountCategory"
                                placeholder="Search"
                                value={this.state.accountCategory}
                                onChange={this.handleAccountCategory}
                                options={this.state.accountCategories}
                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8  inline-block">
                            Main Account
                                <Select
                                className=" py-8"
                                name="mainAccount"
                                placeholder="Search"
                                value={this.state.mainAccount}
                                onChange={this.handleMainAccount}
                                options={this.state.mainAccounts}
                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-2/5 p-8  inline-block">
                            Document Recall
                                <ReactTable
                                className={classNames(classes.root, "-striped -highlight")}
                                getTrProps={(state, rowInfo, column) => {
                                    return {
                                        className: "cursor-pointer",
                                        onClick: (e, handleOriginal) => {
                                            if (rowInfo) {
                                                this.loadDraftDetails(rowInfo.original.id);
                                            }
                                        }
                                    }
                                }}
                                data={this.state.draftList}
                                columns={[
                                    
                                    {
                                        Header: "Document No",
                                        accessor: "draftCode",
                                    },
                                    {
                                        Header: "Date",
                                        accessor: "date",
                                    },

                                ]}
                                defaultPageSize={2}
                                noDataText="No Drafts found"
                            />
                        </div>
                    </div>

                    <ReactTable
                        className={classNames(classes.root, "-striped -highlight m-12 p-20 border-2 border-green-darkest")}
                        getTrProps={(state, rowInfo, column) => {
                            return {
                                className: "cursor-pointer",
                            }
                        }}
                        data={this.state.accountList}
                        columns={[
                            {
                                Header: "Ledger Ref. No",
                                accessor: "ref_no",
                                filterable: true,
                                className: 'mx-20',
                                width: 200,
                            },
                            {
                                Header: "Ledger Name",
                                accessor: "name",
                                filterable: true,
                                className: "",
                            },

                            {
                                Header: "Type | Balance",
                                className: "justify-end",
                                width: 500,
                                Cell: row => (

                                    <Formsy
                                        className="w-full"
                                        onValidSubmit={this.updateBalance}
                                    >
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="ledgerAccId"
                                            value={row.original.id}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="mainId"
                                            value={row.original.mainId}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="balanceTypeTmp"
                                            value={row.original.type}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="balanceAmountTmp"
                                            value={row.original.value}
                                        />
                                        <MSelect
                                            className="1/4 mx-12 openin-balance-feild-height"
                                            name="balanceType"
                                            // value="Credit"
                                            value={row.original.isSingle ? (

                                                row.original.type
                                            ):(

                                                row.original.type
                                            )}
                                            required
                                            onChange={(ev) => {
                                                ev.stopPropagation();
                                                this.pushType(ev, row.original.index);
                                            }}
                                        >
                                            <MenuItem value='Credit'>Credit</MenuItem>
                                            <MenuItem value='Debit'>Debit</MenuItem>
                                        </MSelect>
                                        <TextField
                                            type="number"
                                            name="balanceAmount"
                                            className="text-right"
                                            value={row.original.isSingle ? (

                                                null
                                            ):(

                                                row.original.value
                                            )}
                                            onChange={(ev) => {
                                                ev.stopPropagation();
                                                this.pushValue(ev, row.original.index);
                                            }}
                                        />
                                        {row.original.isSingle ? (
                                            <Button
                                                type="submit"
                                                className="w-1/4 mx-12"
                                                variant="raised"
                                                color="secondary"
                                                size="small"

                                            >
                                                Update
                                     </Button>
                                        ) : (
                                                " "
                                            )}
                                    </Formsy>

                                )
                            },

                        ]}
                        defaultPageSize={10}
                        noDataText="No Accounts found"
                    />

                    <DialogActions className="justify-right p-20">
                        <Button
                            type="submit"
                            variant="raised"
                            color="secondary"
                            onClick={(ev) => {
                                ev.stopPropagation();
                                this.updateBalanceAll();
                            }}
                        >
                            Update All
                          </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={(ev) => {
                                ev.stopPropagation();
                                this.draftLedgerBalance();
                            }}
                        >
                            Draft
                          </Button>
                        <Button
                            variant="raised"
                            color="default"
                        >
                            Help
                          </Button>
                    </DialogActions>


                </fieldset>
            );
        }
    }

    componentWillMount() {

        var accountTypes = [];
        // axios.get('http://localhost:5009/accountType/getAccountTypes')
        axios.get(window.accountServer + '/accountType/getAccountTypes')

            .then(response => {

                for (let i = 0; i < response.data.accountTypes.length; i++) {

                    accountTypes.push({
                        value: response.data.accountTypes[i].ID_ACCOUNT_TYPE,
                        label: response.data.accountTypes[i].NAME
                    });
                }
                this.setState({ accountTypes: accountTypes });

            }).catch(function (error) {
                console.log("err " + error);
            });

        //======================================================

        this.getDraftList();
    }
}

export default withStyles({ withTheme: true })(withRouter(connect()(withAlert(openningBalance))));


// WEBPACK FOOTER //
// ./src/main/content/accounting/openningBalance/openningBalance.js